import { CheckCircle, Error } from "@mui/icons-material";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { GqlJob } from "~/__generated__";

import useWorkerJobStatusMonitor from "../../hooks/useWorkerJobStatusMonitor";

type indicatorIconKey = keyof typeof indicatorIcon;

const indicatorIcon = {
    active: <CircularProgress size={24} color="inherit" />,
    finished: <CheckCircle color="inherit" />,
    error: <Error color="inherit" />,
};

type indicatorTextKey = keyof typeof indicatorText;
const indicatorText = {
    active: "workerJobStatus.working",
    finished: "workerJobStatus.success",
    error: "workerJobStatus.failed",
};

type Props = {
    worker: string;
    jobId: string;
    onFinished?: (job: GqlJob) => void;
    renderFeedback?: (jobData: GqlJob) => JSX.Element;
};

export default function WorkerJobStatus({ worker, jobId, renderFeedback, onFinished }: Props) {
    const { t } = useTranslation("app");

    const { status, data } = useWorkerJobStatusMonitor({
        worker: worker,
        jobId: jobId,
        onFinished: onFinished,
    });
    return (
        <Stack>
            <Stack direction="row" alignItems="center" gap={1}>
                {indicatorIcon[status as indicatorIconKey]}

                <Stack direction="column" flex={1}>
                    <Typography variant="h5">{t(indicatorText[status as indicatorTextKey])}</Typography>

                    {data?.message && <Typography variant="caption">{data.message}</Typography>}
                </Stack>
            </Stack>
            {data && renderFeedback?.(data)}
        </Stack>
    );
}
